import React, { useEffect, useState } from "react";

const MultiSelect = (props) => {

    const [searchedList, setSearchedList] = useState(props.list)
    const [search, setSearch] = useState("")

    useEffect(() => {
        const filtered = props.list?.filter((item) => {
            const itemName = item?.name?.toLowerCase?.() || '';
            const searchTerm = search?.toLowerCase?.() || '';
            return itemName.includes(searchTerm);
        });
        setSearchedList(filtered || []);
    }, [search])

    return (
        <div className="w-full" ref={ props.divRef }>
            <div className="relative mt-2">
                <div className="SelectedTagBox">
                    <div className={ "SelectedTags" }>
                        { props.selectedItems?.map((tag) => (
                            <div key={ tag._id }
                                 className="SelectedTag">
                                { tag.name }
                                <button type="button" className="ml-2 text-indigo-700 hover:text-indigo-900"
                                        onClick={ () => props.selectItem(tag) }>
                                    <img alt={ "Logo" } src={ "/media/icons/closeIcon.svg" }
                                         className={ "w-[18px] h-[18px]" }/>
                                </button>
                            </div>
                        )) }
                    </div>
                    <button onClick={ () => props.setOpenSelect(false) }>
                        <img alt={ "Logo" } src={ "/media/icons/closeIcon.svg" } className={ "w-[18px] h-[18px]" }/>
                    </button>
                </div>
                <div className="TagDropDown">
                    <div className="relative flex items-center w-full">
                    <span className="absolute left-3">
                            <img alt={ "Logo" } src={ "/media/icons/searchIcon.svg" }
                                 className={ "h-[18px] w-[18px]" }/>
                    </span>
                        <input type="text" placeholder="Search"
                               className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg outline-none"
                               onChange={ (e) => setSearch(e.target.value) }
                        />
                    </div>
                    <ul className="w-full">
                        { searchedList?.map((tag) => (
                            <div className={ "p-2 flex  flex-col gap-1" } key={ tag._id }>
                                <div className={ "flex items-center justify-between" }>
                                    <li
                                        key={ tag._id }
                                        className="flex items-center p-1 "
                                    >
                                        <input
                                            type="checkbox"
                                            checked={ props.selectedItems?.find((item) => item._id === tag._id) }
                                            onChange={ () => props.selectItem(tag) }
                                            className={ "CustomCheckbox" }
                                        />
                                        { tag.name }
                                    </li>
                                    <img alt={ "Logo" } src={ "/media/icons/tag.svg" }
                                         className={ "h-[18px] w-[18px]" }/>
                                </div>
                                <div className={ "HorizontalDivider" }></div>
                            </div>
                        )) }
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default MultiSelect;